// extracted by mini-css-extract-plugin
module.exports = {"container":"contacts_container__2f5gn","list":"contacts_list__3jQii","linc":"contacts_linc__XF88M"};